import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";

function flatten<Type>(items: Array<Type>): Type {
  return items.reduce<Type>((acc, item) => ({ ...acc, ...item }), {} as Type);
}

function linkResources<Resource, Type extends LinkedResource<Resource>>(
  httpClient: HttpClient,
  resource: Type,
): Promise<Type> {
  if (!(typeof resource === "object" && "_links" in resource)) {
    return Promise.resolve(resource);
  }

  const promises = Object.entries(resource._links).map(([key, { href }]) =>
    httpClient
      .sendHttpRequest<Partial<Resource> | { _embedded: Partial<Resource> }>({
        endpoint: href,
        baseUrl: "",
        method: HttpMethods.GET,
      })
      .then((response) =>
        "_embedded" in response ? response._embedded : { [key]: response },
      ),
  );

  return Promise.all(promises.map((p) => p.catch((e) => ({}) as any))).then(
    (parts) => ({ ...resource, ...flatten(parts as Partial<Type>[]) }),
  );
}

export { linkResources };
